<div style="width: 500px">
  <p
    color="#0F72B1"
    font-size="medium"
    style="
      margin: 0px;
      color: rgb(15, 114, 177);
      font-size: 14px;
      line-height: 22px;
    "
  >
    <span>Respeitosamente,</span>
  </p>
  <div
    style="
      margin-top: 10px;
      border-bottom: 1px solid rgb(166, 166, 166);
      width: 100%;
    "
  ></div>
  <div style="text-align: center; margin-top: 10px">
    <h2
      style="
        margin: 0px;
        font-size: 16px;
        color: rgb(15, 114, 177);
        font-weight: 600;
      "
    >
      <span>{{name}}</span>
    </h2>
    <p
      style="
        margin: 0px;
        color: rgb(15, 114, 177);
        font-size: 14px;
        line-height: 22px;
      "
    >
      <span>{{cargo}}</span>
    </p>
    <p
      style="
        margin: 0px;
        font-weight: 500;
        color: rgb(15, 114, 177);
        font-size: 14px;
        line-height: 22px;
      "
    >
      <span>BS|Code Brasil</span>
    </p>
  </div>
  <div
    style="
      margin-top: 10px;
      border-bottom: 1px solid rgb(166, 166, 166);
      width: 100%;
    "
  ></div>
  <div style="display: flex; align-items: center; margin-bottom: 10px">
    <div style="width: 80%; padding-left: 20px">
      <div style="display: flex; align-items: center; margin-bottom: 5px">
        <img
          src="https://cdn2.hubspot.net/hubfs/53/tools/email-signature-generator/icons/phone-icon-2x.png"
          alt="mobilePhone"
          width="13"
          style="margin-right: 10px"
        />
        <a
          [href]="'tel:+55' + phone"
          style="
            text-decoration: none;
            color: rgb(15, 114, 177);
            font-size: 12px;
          "
        >
          +55 {{phone}}
        </a>
      </div>
      <div style="display: flex; align-items: center; margin-bottom: 5px">
        <img
          src="https://cdn2.hubspot.net/hubfs/53/tools/email-signature-generator/icons/email-icon-2x.png"
          alt="emailAddress"
          width="13"
          style="margin-right: 10px"
        />
        <a
          [href]="'mailto:' + mail"
          style="
            text-decoration: none;
            color: rgb(15, 114, 177);
            font-size: 12px;
          "
        >
          {{mail}}
        </a>
      </div>
      <div style="display: flex; align-items: center">
        <img
          src="https://cdn2.hubspot.net/hubfs/53/tools/email-signature-generator/icons/link-icon-2x.png"
          alt="website"
          width="13"
          style="margin-right: 10px"
        />
        <a
          href="//www.bscode.com.br"
          style="
            text-decoration: none;
            color: rgb(15, 114, 177);
            font-size: 12px;
          "
        >
          www.bscode.com.br
        </a>
      </div>
    </div>
    <!-- Logo -->
    <div style="width: 20%; text-align: center">
      <img
        src="data:image/png;base64,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"
        alt="Logo"
        style="max-width: 100%; height: auto"
      />
    </div>
  </div>
  <div
    style="
      margin-top: 10px;
      border-bottom: 1px solid rgb(166, 166, 166);
      width: 100%;
    "
  ></div>
  <div style="margin-top: 10px; font-size: x-small">
    “As informações contidas neste e-mail e seus anexos são confidenciais,
    legalmente protegidos. São dirigidos exclusivamente ao seu destinatário. A
    leitura, o exame, a retransmissão, a divulgação, a distribuição, a cópia ou
    outro uso dessas informações, ou ainda a tomada de qualquer ação neles
    baseada, por pessoas ou entidades que não sejam o destinatário, constituem
    obtenção de dados por meio ilícito e configuram ofensa ao Art. 5º, inciso
    XII, da Constituição Federal. Caso esta mensagem tenha sido recebida por
    engano, por favor, inutilize-a e, se possível, avise ao remetente por
    e-mail.”
  </div>
</div>
